class Client {
    constructor(props){
        let updatedProps = props || {}
        this.id = updatedProps['_id'] || updatedProps.id;
        this.userId = updatedProps.userId;
        this.client = updatedProps.client;
        this.clientId = updatedProps.clientId;
        this.clientTitle = updatedProps.clientTitle;
        this.access_token = updatedProps.access_token;
        this.refresh_token = updatedProps.refresh_token;
        this.expiry_date = updatedProps.expiry_date;
        this.scope = updatedProps.scope;
        this.token_type = updatedProps.token_type;
        this.extinfo = updatedProps.extinfo;
        this.workflowIds = updatedProps.workflowIds;
        this.created = updatedProps.createdAt || new Date().toString().slice(0,24);
    }
}

export default Client
